"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBrowserCountsQueryWrapper = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const renderQueryResult_1 = require("../renderQueryResult");
class CatalogBrowserCountsQueryWrapper extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderWebClientResponse = (response) => {
            if (response.type === 'SUCCESS') {
                return this.props.children({
                    databasesCount: response.databasesCount,
                    filesCount: null,
                    tablesCount: response.tablesCount,
                });
            }
            else {
                return this.props.children({
                    databasesCount: null,
                    filesCount: null,
                    tablesCount: null,
                });
            }
        };
        this.renderChildrenWithEmptyCounts = () => {
            return this.props.webClientResult
                ? this.renderWebClientResponse(this.props.webClientResult)
                : this.props.children({
                    databasesCount: null,
                    filesCount: null,
                    tablesCount: null,
                });
        };
        this.renderChildrenWithData = (data) => {
            return this.props.webClientResult
                ? this.renderWebClientResponse(this.props.webClientResult)
                : this.props.children({
                    databasesCount: data.databasesConnection
                        ? data.databasesConnection.totalCount
                        : null,
                    filesCount: null,
                    tablesCount: data.databaseTablesConnection
                        ? data.databaseTablesConnection.totalCount
                        : null,
                });
        };
        this.renderNoData = () => {
            return this.props.webClientResult
                ? (this.renderWebClientResponse(this.props.webClientResult))
                : (react_1.default.createElement(react_1.default.Fragment, null,
                    (0, data_catalog_shared_1.reportNoData)(),
                    this.renderChildrenWithEmptyCounts()));
        };
        this.renderDataWithError = (data, errorCode) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                (0, data_catalog_shared_1.reportGraphQLError)(errorCode),
                this.props.webClientResult
                    ? this.renderWebClientResponse(this.props.webClientResult)
                    : this.renderChildrenWithData(data)));
        };
        this.renderError = (errorCode) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                (0, data_catalog_shared_1.reportGraphQLError)(errorCode),
                this.props.webClientResult
                    ? this.renderWebClientResponse(this.props.webClientResult)
                    : this.renderChildrenWithEmptyCounts()));
        };
    }
    render() {
        return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.CatalogSelectorDropdownCountsDocument, variables: {
                textSearch: this.props.textSearch,
                hasActiveWarning: this.props.hasActiveWarning,
                isCertified: this.props.isCertified,
            } }, (result) => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
                renderLoading: this.renderChildrenWithEmptyCounts,
                renderData: this.renderChildrenWithData,
                renderNoData: this.renderNoData,
                renderDataWithError: this.renderDataWithError,
                renderError: this.renderError,
            } }))));
    }
}
exports.CatalogBrowserCountsQueryWrapper = CatalogBrowserCountsQueryWrapper;
//# sourceMappingURL=CatalogBrowserCountsQueryWrapper.js.map